import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
/* import __COLOCATED_TEMPLATE__ from './second-factor-add-security-key.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { bufferToBase64, isWebauthnSupported, stringToBuffer } from "discourse/lib/webauthn";
import { MAX_SECOND_FACTOR_NAME_LENGTH } from "discourse/models/user";
import I18n from "discourse-i18n";
import TEMPLATE from "./second-factor-add-security-key.hbs";
import { setComponentTemplate } from "@ember/component";
let SecondFactorAddSecurityKey = (_class = class SecondFactorAddSecurityKey extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "capabilities", _descriptor, this);
    _initializerDefineProperty(this, "loading", _descriptor2, this);
    _initializerDefineProperty(this, "errorMessage", _descriptor3, this);
    _initializerDefineProperty(this, "securityKeyName", _descriptor4, this);
    _defineProperty(this, "maxSecondFactorNameLength", MAX_SECOND_FACTOR_NAME_LENGTH);
  }
  get webauthnUnsupported() {
    return !isWebauthnSupported();
  }
  securityKeyRequested() {
    let key;
    if (this.capabilities.isIOS && !this.capabilities.isIpadOS) {
      key = "user.second_factor.security_key.iphone_default_name";
    } else if (this.capabilities.isAndroid) {
      key = "user.second_factor.security_key.android_default_name";
    } else {
      key = "user.second_factor.security_key.default_name";
    }
    this.securityKeyName = I18n.t(key);
    this.loading = true;
    this.args.model.secondFactor.requestSecurityKeyChallenge().then(response => {
      if (response.error) {
        this.errorMessage = response.error;
        return;
      }
      this.errorMessage = isWebauthnSupported() ? null : I18n.t("login.security_key_support_missing_error");
      this.loading = false;
      this.challenge = response.challenge;
      this.relayingParty = {
        id: response.rp_id,
        name: response.rp_name
      };
      this.supported_algorithms = response.supported_algorithms;
      this.user_secure_id = response.user_secure_id;
      this.existing_active_credential_ids = response.existing_active_credential_ids;
    }).catch(error => {
      this.args.closeModal();
      this.args.model.onError(error);
    }).finally(() => this.loading = false);
  }
  registerSecurityKey() {
    if (!this.securityKeyName) {
      this.errorMessage = I18n.t("user.second_factor.security_key.name_required_error");
      return;
    }
    const publicKeyCredentialCreationOptions = {
      challenge: Uint8Array.from(this.challenge, c => c.charCodeAt(0)),
      rp: {
        name: this.relayingParty.name,
        id: this.relayingParty.id
      },
      user: {
        id: Uint8Array.from(this.user_secure_id, c => c.charCodeAt(0)),
        displayName: this.args.model.secondFactor.username_lower,
        name: this.args.model.secondFactor.username_lower
      },
      pubKeyCredParams: this.supported_algorithms.map(alg => {
        return {
          type: "public-key",
          alg
        };
      }),
      excludeCredentials: this.existing_active_credential_ids.map(credentialId => {
        return {
          type: "public-key",
          id: stringToBuffer(atob(credentialId))
        };
      }),
      timeout: 20000,
      attestation: "none",
      authenticatorSelection: {
        // see https://chromium.googlesource.com/chromium/src/+/master/content/browser/webauth/uv_preferred.md for why
        // default value of preferred is not necessarily what we want, it limits webauthn to only devices that support
        // user verification, which usually requires entering a PIN
        userVerification: "discouraged"
      }
    };
    navigator.credentials.create({
      publicKey: publicKeyCredentialCreationOptions
    }).then(credential => {
      let serverData = {
        id: credential.id,
        rawId: bufferToBase64(credential.rawId),
        type: credential.type,
        attestation: bufferToBase64(credential.response.attestationObject),
        clientData: bufferToBase64(credential.response.clientDataJSON),
        name: this.securityKeyName
      };
      this.args.model.secondFactor.registerSecurityKey(serverData).then(response => {
        if (response.error) {
          this.errorMessage = response.error;
          return;
        }
        this.args.model.markDirty();
        this.errorMessage = null;
        this.args.closeModal();
        if (this.args.model.enforcedSecondFactor) {
          window.location.reload();
        }
      }).catch(error => this.args.model.onError(error)).finally(() => this.loading = false);
    }, err => {
      if (err.name === "InvalidStateError") {
        this.errorMessage = I18n.t("user.second_factor.security_key.already_added_error");
        return;
      }
      if (err.name === "NotAllowedError") {
        this.errorMessage = I18n.t("user.second_factor.security_key.not_allowed_error");
        return;
      }
      this.errorMessage = err.message;
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capabilities", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "securityKeyName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "securityKeyRequested", [action], Object.getOwnPropertyDescriptor(_class.prototype, "securityKeyRequested"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerSecurityKey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerSecurityKey"), _class.prototype)), _class);
export { SecondFactorAddSecurityKey as default };
setComponentTemplate(TEMPLATE, SecondFactorAddSecurityKey);